import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons"
import { Dropdown, MenuProps } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

export interface OptionButtonsPropsBase<T> {
    record?: T
    onEdit?: (record: T) => void
    onDelete?: (record: T) => void
    onView?: (record: T) => void
    children: React.ReactNode
}

interface OptionButtonsProps<T> extends OptionButtonsPropsBase<T> {
    isEditDisabled: boolean
    isDeleteDisabled: boolean
}

export const OptionButtons = <T,>({ record, onEdit, onDelete, onView, children, isEditDisabled, isDeleteDisabled }: OptionButtonsProps<T>) => {
    const { t } = useTranslation()

    if (!record) {
        return children
    }

    const items = [
        onView && {
            key: "view",
            label: t("purchaseOrders:optionButtons.view"),
            icon: <EyeOutlined />,
            onClick: () => {
                onView(record)
            },
        },
        onEdit && {
            key: "edit",
            label: <span className={isEditDisabled ? "text-gray-700" : ""}>{t("purchaseOrders:optionButtons.edit")}</span>,
            icon: <EditOutlined className={isEditDisabled ? "text-gray-700" : ""} />,
            disabled: isEditDisabled,
            onClick: () => {
                if (!isEditDisabled) {
                    onEdit(record)
                }
            },
        },
        onDelete && {
            key: "delete",
            label: <span className={isDeleteDisabled ? "text-gray-700" : ""}>{t("purchaseOrders:optionButtons.delete")}</span>,
            icon: <DeleteOutlined className={isDeleteDisabled ? "text-gray-700" : ""} />,
            disabled: isDeleteDisabled,
            onClick: () => {
                if (!isDeleteDisabled) {
                    onDelete(record)
                }
            },
        },
    ].filter(Boolean) as MenuProps["items"]

    return (
        <div onClick={(e) => e.stopPropagation()} style={{ display: "inline-block" }}>
            <Dropdown
                menu={{
                    items,
                    onClick: undefined, // Remove the global onClick since we're handling it per item
                }}
                trigger={["click"]}
            >
                {children}
            </Dropdown>
        </div>
    )
}
